import React from "react"

import { FloorFormModel } from "features/floor-management/types/FloorFormModel"

import {
  NewFloorOverlayView,
  NewFloorOverlayViewProps
} from "./NewFloorOverlayView"

export interface NewFloorOverlayModel {
  floorFormModel: FloorFormModel
  isLoading?: boolean
  isSubmitting?: boolean
  onCancel: () => void
}

export interface NewFloorOverlayProps
  extends NewFloorOverlayModel,
    Pick<NewFloorOverlayViewProps, "autoFocus"> {}

export const NewFloorOverlay = React.memo((props: NewFloorOverlayProps) => (
  <NewFloorOverlayView {...props} formID="new-floor-overlay-form" />
))

NewFloorOverlay.displayName = "NewFloorOverlay"
